import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initBlogPagination from '../sections/blog/initBlogPagination';

const SEARCH_ARTICLES_SELECTOR = '[data-blog-search-results]';

ready(() => {
  initBlogPagination(SEARCH_ARTICLES_SELECTOR);
});

onShopifySectionLoad(() => {
  initBlogPagination(SEARCH_ARTICLES_SELECTOR);
});
